export const ThemeColors = {
    themePrimary: '#F85B07',
    themeSecondary: '#752C8F',
    themeTertiary: 'rgba(139, 77, 161, 0.5)',
}
